import { ChangeDetectorRef, Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class ChangeDetectionService {

  public static useManualChangeDetection = true;

  public constructor() {
  }

  public static detach(cdr: ChangeDetectorRef): void {
    if (ChangeDetectionService.useManualChangeDetection && cdr != null) {
      cdr.detach();
    }
  }

  public static detectChanges(cdr: ChangeDetectorRef): void {
    if (ChangeDetectionService.useManualChangeDetection && cdr != null) {
      //console.log('manual detect change cycle triggered');
      try {
        cdr.detectChanges();
      } catch (e) {
        console.error('Change detection error:', e);
      }
    }
  }
}
